define('lib/Podio.UI.Lightbox',['require','translate','jquery','lib/Podio.UI.Modal','lib/Podio.UI','lib/Podio.Event.UI','signals'],function(require) {

  var t = require('translate');
  var $ = require('jquery');
  var modal = require('lib/Podio.UI.Modal');
  var podioUI = require('lib/Podio.UI');
  var uiEvent = require('lib/Podio.Event.UI');
  var signalsLib = require('signals');

  var domPreloadedImage, elmNextImage, elmPrevImage;

  var defaultOptions = {
    hideOnOutsideClick: true,
    className : 'lightbox',
    keepScrollPosition: true,
    hideHandler: onModalHide
  };

  var signals = {
    onLightboxClosed: new signalsLib.Signal(),
    onLightboxOpened: new signalsLib.Signal()
  };

  function calculateBoundingBoxDimensions(width, height, bWidth, bHeight) {

    var new_width = width;
    var new_height = height;

    var aspect_ratio = width / height;

    if (new_width > bWidth) {
      new_width = bWidth;
      new_height = new_width / aspect_ratio;
    }

    if (new_height > bHeight) {
      new_height = bHeight;
      new_width = new_height * aspect_ratio;
    }

    return { width: new_width, height: new_height };
  }

  function onModalHide() {
    $(document).unbind('keydown.lightbox', onKeyDown);

    // Signals
    signals.onLightboxClosed.dispatch();

    return true;
  }

  function changeImage(elmItem, showLoader) {
    if(showLoader) {
      showLoading();
    } else {
      $('div.modal .loading-overlay').show();
    }

    var itemLinks = $('a[rel=' + elmItem.attr('rel') + ']');
    var url = elmItem.attr('href');
    var thumbUrl = elmItem.data('thumb-url');

    if(thumbUrl) {
      url = thumbUrl;
    }

    var currentIndex = itemLinks.index(elmItem);
    var prevIndex = currentIndex - 1;
    if(prevIndex >= 0) {
       elmPrevImage = itemLinks.eq(prevIndex);
    } else {
      elmPrevImage = null;
    }
    elmNextImage = itemLinks.eq(currentIndex+1);

    var showImage = show.curry(url, elmItem);

    domPreloadedImage = new Image();
    domPreloadedImage.onload = showImage;
    domPreloadedImage.onerror = showImage;
    domPreloadedImage.src = url;
  }

  function onLightBoxLinkClicked(elmTarget, e) {

    if(e.metaKey || e.shiftKey || e.ctrlKey ) {
      return false;
    }

    e.preventDefault();

    $(document).bind('keydown.lightbox', onKeyDown);

    changeImage(elmTarget, true);
  }

  function onLightboxNavLeftClicked() {
    if(elmPrevImage && elmPrevImage.length) {
      changeImage(elmPrevImage);
    }
  }

  function onLightboxNavRightClicked() {
    if(elmNextImage && elmNextImage.length) {
      changeImage(elmNextImage);
    }
  }

  function onLightboxImageClicked(elmTarget) {
    modal.hide();
  }

  function showLoading() {
    modal.showLoading(void 0, {width: 300});
  }

  function onKeyDown(e) {
    if (e.keyCode == podioUI.KeyCodes.LeftArrow) {
      if(elmPrevImage && elmPrevImage.length) {
        changeImage(elmPrevImage);
      }
    }
    if (e.keyCode == podioUI.KeyCodes.RightArrow) {
      if(elmNextImage && elmNextImage.length) {
        changeImage(elmNextImage);
      }
    }
  }

  function show(url, elmItem, e) {
    var width = e && e.target && e.target.width || 500;
    var height = e && e.target && e.target.height || 500;
    var title = elmItem && elmItem.attr('title') || '';
    var viewportWidth = $(window).width() - 80;
    var viewportHeight = $(window).height() - 127;
    var options = $.extend(defaultOptions, { positionTop: $(document).scrollTop() + 35, disableCloseOptions : false });
    var navClass = '';
    var newImageSize = calculateBoundingBoxDimensions(width, height, viewportWidth, viewportHeight);
    var modalWidth = newImageSize.width + 10;

    var imageUrl = elmItem.attr('href');

    var context = '';
    if (elmItem.data('context_title') && elmItem.data('context_href') && elmItem.data('context_icon')) {
      context = '<a class="context_link" href="'+elmItem.data('context_href')+'">';
      context += '<span class="sprite-16 '+elmItem.data('context_icon')+'"></span>';
      context += elmItem.data('context_title');
      context += '</a>';
    }

    if(elmPrevImage && elmPrevImage.length) {
      navClass = navClass + ' left';
    }

    if(elmNextImage && elmNextImage.length) {
      navClass = navClass + ' right';
    }

    if(modalWidth < 400) {
      modalWidth = 400;
    }

    options.headerHtml = '<h2>' + title.htmlEncode() + '</h2> <a href="' + imageUrl + '?force_download=true" class="download-link" download>' + t('Download original image #lightbox') + '</a>' + context;
    options.className = 'lightbox' + navClass;
    options.width = modalWidth;

    var markup = '<div class="loading-overlay"><div></div></div><div class="nav left"><div class="icon"></div></div><div class="nav right"><div class="icon"></div></div><img src="' + url + '" width="' + newImageSize.width + '" height="' + newImageSize.height + '" alt="" />';

    modal.show(markup, options);

    // Signals
    signals.onLightboxOpened.dispatch();
  }

  uiEvent.bind('click', "a[rel^='lightbox']", onLightBoxLinkClicked, true);
  uiEvent.bind('click', "div.modal .content.lightbox img", onLightboxImageClicked);
  uiEvent.bind('click', "div.modal .content.lightbox .nav.left", onLightboxNavLeftClicked);
  uiEvent.bind('click', "div.modal .content.lightbox .nav.right", onLightboxNavRightClicked);

  return {
    show: show,
    signals: signals
  };
});


